import React from 'react'
import {useQuery} from '@apollo/react-hooks'
import gql from 'graphql-tag'
import {createUseStyles} from 'react-jss'
import {Link} from 'react-router-dom'

import routesHelper from '@prepler/core/lib/routesHelper'

import Loader from '../common/loader'
import GraphqlError from '../dev/graphqlError'

const useStyles = createUseStyles(theme => ({
	container: {
		'& h3': {
			padding: '15px 5px 20px',
			textAlign: 'center',
			fontSize: '22px',
			'@media screen and (min-width: 992px)': {
				fontSize: '32px',
			},
			fontWeight: theme.fontWeight.light
		}
	},
	ul: {
		fontSize: '0',
		margin: '0 -1.16% -20px',
		'& li': {
			display: 'inline-block',
			position: 'relative',
			padding: '0 1.16%',
			margin: '0 0 32px',
			verticalAlign: 'top',
			listStyle: 'none',
			fontSize: '16px',
			width: '100%',
			'& a': {
				textDecoration: 'none',
				wordBreak: 'normal',
				whiteSpace: 'normal',
				'& $wrappedImage': {
					height: '0',
					paddingBottom: '31.25%',
					position: 'relative',
					// background: '#fff',
					overflow: 'hidden',
					'& > div': {
						display: 'inline-block'
					},
					'& > div, & > div img': {
						position: 'absolute',
						top: '0',
						bottom: '0',
						left: '0',
						right: '0'
					},
					'& > div img': {
						display: 'block',
						maxHeight: '100%',
						maxWidth: '100%',
						margin: 'auto',
						borderRadius: '0',
						border: 'none',
						verticalAlign: 'middle'
					}
				},
				'& > h3': {
					fontSize: '14px',
					color: '#2c373b',
					lineHeight: '19px',
					fontWeight: theme.fontWeight.normal,
					margin: '13px 0 0',
					padding: '0px'
				}
			}
		}
	},
	wrappedImage: {}
}));

const ARTICLES_POPULAR = gql`
	query ArticlesPopular($slug: String!) {
		articlesPopular(slug: $slug) {
			id
			slug
			title
			photo {
				medium
				medium4
				medium8
			}
		}
	}
`;

const BlogPosts = ({slug}) => {
	const classes = useStyles();

	const {loading, error, data} = useQuery(ARTICLES_POPULAR, {variables: {slug}, context: {authPublic: true}});

	if (loading) return <Loader/>;
	if (error) return <GraphqlError error={error}/>;

	const {
		articlesPopular: articles
	} = data;

	return articles.length > 0 ? (
		<div className={classes.container}>
			<h3>Popular Posts</h3>
			<ul className={classes.ul}>
				{articles.map(({id, slug, title, photo}) =>
					<li key={id}>
						<Link to={{pathname: routesHelper.articlePath({id: slug || id})}}>
							<div className={classes.wrappedImage}>
								<div>
									<img
										alt="" src={photo.medium}
										srcSet={`${photo.medium4} 480w, ${photo.medium8} 240w`}
									/>
								</div>
							</div>
							<h3>{title}</h3>
						</Link>
					</li>
				)}
			</ul>
		</div>
	) : null;
}

BlogPosts.fragments = {
	article: gql`
		fragment BlogPostsArticle on Article {
			id
			slug
			title
			photo {
				medium
				medium4
				medium8
			}
		}
	`,
}

export default BlogPosts;
